import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=3b0bf867&scoped=true&"
import script from "./guide.vue?vue&type=script&lang=js&"
export * from "./guide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0bf867",
  null
  
)

export default component.exports